export default __webpack_public_path__ + "static/media/HRRealCase.b8ba26d3.jpg";